const applicantChangeField = {
    applicantDataInfo: {
        title: '要保人基本資料',
        name: '要保人姓名',
        engName: '要保人英文譯音',
        id: '身分證字號',
        country: '國籍',
        birthday: '出生日期',
        relation: '與被保險人關係',
    },
    profession: {
        title: '職業內容',
        unit: '目前就職的公司名稱',
        nature: '公司行業類別',
        position: '職位',
        content: '工作內容',
        code: '職業代碼',
        partTimeCode: '兼職職業代碼(非必填)',
        partTimeContent: '兼職工作內容(非必填)'
    },
    connectionInfo: {
        title: '要保人聯絡資訊',
        mobileCountry: '',
        mobile: '行動電話',
        email: 'E-mail',
        applicantInfoAddress: '住所(戶籍地址)',
        applicantInfoTel: '住所(戶籍地址)電話',
        chargeInfoAddress: '收費地址',
        chargeInfoTel: '收費電話',
        applicantInfo: {
            city: '縣市',
            cityArea: '鄉鎮',
            address: '地址',
            telAreaCode: '區碼',
            tel: '電話',
            telExt: '分機',
        },
        chargeInfo: {
            city: '縣市',
            cityArea: '鄉鎮',
            address: '地址',
            telAreaCode: '區碼',
            tel: '電話',
            telExt: '分機',
        },
    },
    riderCancellation: {
        title: '附約取消',
    },
};
Object.freeze(applicantChangeField);
export default applicantChangeField;
